// Dependencies

import { type App } from '~/app';

import { getMainEnquiryForm } from '../form-and-content/modal-form/modal-form';

export default (app: App) => {
    app.logger.debug('[Stockland FE] Initialise Stockland Takeover Callout Component');

    app.afterMount
        .then(() => setTimeout(() => {
            mountEnquireContact()
            removeModalForm()
            removeTakeoverForm()
        }, 200))
        .catch((error: ErrorOptions) => {
            throw new Error('[Stockland FE] Unable to register Stockland Takeover Callout Component', error);
        });

    return () => {
        app.logger.debug('[DXA] Takeover Callout destroyed');
    };
}


function mountEnquireContact() {
    const contactFormButtons = document.querySelectorAll<HTMLElement>(".takeover-callout-button");
    const takeOverCalloutContainer = document.querySelector<HTMLElement>(".takeover-callout");

    for (const button of contactFormButtons) {
        const parent = button.closest<HTMLElement>('.takeover-callout-parent-container')
        const contactForm = parent?.querySelector<HTMLElement>(".takeover-callout-form-container")
        const info = parent?.querySelector<HTMLElement>(".takeover-callout-info-container")
        const columns = parent?.querySelector<HTMLElement>(".takeover-callout-columns")

        button.setAttribute('type', 'button')

        const modalButton = getMainEnquiryForm();


        if (!button.dataset.hasListener) {
            button.addEventListener("click", () => {
                // Epi form should have been removed if it is the same
                const epiForm = takeOverCalloutContainer?.querySelector('.EPiServerForms')
                if (modalButton && !epiForm) {
                    const modalButton = getMainEnquiryForm();
                    if (modalButton) {
                        modalButton.click()
                    }
                }
                else if (parent) {
                    contactForm?.classList.remove("hidden");
                    info?.classList.add("hidden")
                    parent.classList.remove("grid-cols-6")
                    parent.classList.remove("md:col-span-6")
                    columns?.classList.remove("md:col-span-4")
                    parent.classList.add("grid-cols-8")
                    parent.classList.add("md:col-span-8")
                    columns?.classList.add("md:col-span-6")
                }
            });
            button.dataset.hasListener = 'true';
        }
    }
}

function removeModalForm() {
    // If the form is visible on mount and it is the same as what is in the modal then remove the modal form
    const takeoverCallout = document.querySelector<HTMLElement>('.takeover-callout');
    const takeoverCalloutForm = document.querySelector<HTMLElement>('.takeover-callout-form-container:not(.hidden) form');
    const modalButton = getMainEnquiryForm();
    const enquiryModal = document.querySelector<HTMLElement>('.modal.enquiry-modal');
    if (takeoverCallout && takeoverCalloutForm && modalButton && enquiryModal && enquiryModal.id === `form-${takeoverCalloutForm.dataset.customFormId}`) {
        const enquiryModalForm = enquiryModal.querySelector<HTMLElement>('.form-container');
        if (enquiryModalForm) {
            enquiryModalForm.remove();
        }
    }
}

function removeTakeoverForm() {
    // If the form is not visible on mount and it is the same as what is in the modal then remove the modal form
    const takeoverCallout = document.querySelector<HTMLElement>('.takeover-callout');
    const takeoverCalloutFormHidden = document.querySelector<HTMLElement>('.takeover-callout-form-container.hidden form');
    const modalButton = getMainEnquiryForm();
    const enquiryModal = document.querySelector<HTMLElement>('.enquiry-modal');
    if (takeoverCallout && takeoverCalloutFormHidden && modalButton && enquiryModal && enquiryModal.id === `form-${takeoverCalloutFormHidden.dataset.customFormId}`) {
        takeoverCalloutFormHidden.remove();
    }
}
